// app/javascript/controllers/modal_controller.js
import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["container", "form"]
  static values = {
    redirectUrl: String
  }

  open() {
    this.containerTarget.classList.remove("hidden")
  }

  openMpn() {
    this.open()
  }

  // Allow turbo:submit-end to close on success
  close(event) {
    if (event?.type === "turbo:submit-end" && !this._submissionSucceeded(event)) {
      return
    }

    this.containerTarget.classList.add("hidden")

    if (event?.type === "turbo:submit-end" && this._submissionSucceeded(event) && this.hasRedirectUrlValue) {
      Turbo.visit(this.redirectUrlValue)
    }
  }

  _submissionSucceeded(event) {
    const success = event.detail?.success
    const response = event.detail?.fetchResponse?.response
    const redirected = response?.redirected

    return Boolean(success || redirected)
  }
}
